import locale from 'element-ui/lib/locale';
import en from 'element-ui/lib/locale/lang/en';
import fr from 'element-ui/lib/locale/lang/fr';
import { useDrupalSettings } from '../config';

const drupalSettings = useDrupalSettings();
const langs = { en, fr };
let localeIsSet = false;

/**
 * Configure ElementUI language locale
 * @see https://element.eleme.io/#/en-US/component/i18n
 */
export default function setElementUILocale() {
  if (localeIsSet) {
    return;
  }
  if (!drupalSettings || !drupalSettings.path || !drupalSettings.path.currentLanguage) {
    locale.use(langs[0]);
  } else {
    locale.use(langs[drupalSettings.path.currentLanguage]);
  }
  localeIsSet = true;
}
